<div class="p-2 row justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        {{ title }}
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<mat-dialog-content class="p-2">
    <!-- Total Well Management Index -->
    <div id="expandGraph"></div>
    <div id="label"></div>
    <!-- End Total Well Management Index -->

    <!-- Unhealthy Well -->
    <div
        [ngClass]="{
            'grid grid-cols-1 md: grid-cols-2 w-full mt-6':
                title == 'Unhealthy Wells'
        }"
    >
        <div id="expandPieLeft"></div>
        <div id="expandPieRight"></div>
        <div class="col-span-2" id="myRiskRanking"></div>
        <div class="col-span-2" id="myStringPercentage"></div>
    </div>
    <!-- End Unhealthy Well -->

    <!-- Well Maintenance -->
    <div
        [ngClass]="{
            'w-full flex flex-col justify-center': title == 'Well Maintenance'
        }"
    >
        <div id="expandMaintenanceTable" class="col-span-2"></div>
        <div id="expandMaintenanceProgress" class="col-span-2"></div>
    </div>
    <!-- End Well Maintenance -->

    <!-- Remedial Progress -->
    <div id="expandStackedChart"></div>
    <!-- End Remedial Progress -->

    <!-- Other Activites -->
    <div id="expandProgressChart"></div>
    <!-- End Other Activites -->
</mat-dialog-content>

<ng-template #closedIcon>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
        />
    </svg>
</ng-template>
